module.exports = __webpack_public_path__ + "img/thumbnail.76c47219.jpg";